import * as React from "react"
import {Form, Icon, Loader} from "semantic-ui-react"
import {Journey} from "../model/places/PlaceTypes"
import {EnsureJourney, JourneyInput} from "../graphql/queries"
import {BookingFormJourneyState} from "../state"
import {journeyDistanceToKmString} from "./JourneyPage"
import {history} from "../App"
import {GraphQL} from "../graphql"

interface BookingWizardDistanceProps {
  journey: Journey
  disabled: boolean
}

function BookingWizardDistance({journey, disabled}: BookingWizardDistanceProps) {
  return (
    <>
      <Form.Field>
        <label>Distance</label>
        <>
          {journeyDistanceToKmString(journey.distance)} km
          <span style={{width: 10, display: "inline-block"}} />
          <Icon
            link={!disabled}
            disabled={disabled}
            onClick={() => {
              if (!disabled) {
                history.push("/journey/" + journey.id)
              }
            }}
            color="grey"
            name="edit"
          />
        </>
      </Form.Field>
    </>
  )
}

interface BookingWizardDistanceQueryProps {
  journey: JourneyInput
  disabled: boolean
}

function BookingWizardDistanceWithJourney(props: BookingWizardDistanceQueryProps) {
  const {journey} = props
  return (
    <GraphQL.Query
      query={EnsureJourney}
      variables={{journey}}
      render={({data}) => {
        if (data) {
          return <BookingWizardDistance {...props} journey={data.ensureJourney} />
        } else {
          return <Loader active />
        }
      }}
    />
  )
}

interface BookingWizardMaybeDistanceProps {
  journey: BookingFormJourneyState
  disabled: boolean
}

function BookingWizardMaybeDistance({
  journey: {origin, destination, waypoints},
  disabled,
}: BookingWizardMaybeDistanceProps) {
  if (!origin || !destination) {
    return <div />
  }
  const journey: JourneyInput = {
    originId: origin.id,
    destinationId: destination.id,
    waypointIds: waypoints.map((x) => x.id),
  }
  return <BookingWizardDistanceWithJourney journey={journey} disabled={disabled} />
}

export {BookingWizardMaybeDistance as BookingWizardDistance}



// WEBPACK FOOTER //
// ./src/components/BookingWizardDistance.tsx